<template>
	<div class='knd-subtitles' ref="maincontainer">
    <div class="audio-player" v-if="activeOption.audio.data">       
      <div ref="audiocontainer">
        <AudioPlayer 
          :src="ASSETS + '' + activeOption.audio.data.attributes.url"
          :muted="store.getters.isMuted"
          :onClickVolume="onClickVolume"
          :play-sound="playSound"
        />
      </div>
    </div>

    <div class="sub">
      <div class='expand-icon-container animation-icon' @click="presentModal" >
        <expandIcon />
      </div>
      <div class="subtitles-container" ref="subtitlescontainer">
        <span 
          v-for="(subtitle, index) in syncData" 
          :key="activeOption.title.replace(' ', '-') + index"
          :id="'c-' + index"
          :class="{active: currentIndex >= index}"
          >
          {{ subtitle.part }}
        </span>
      </div>
    </div>

	</div>
</template>

<script>

import { useStore } from 'vuex'
import { ref, onMounted, watch} from 'vue';

import expandIcon from '@/components/icons/expand';

import {audioSync, scrollToElm} from './audio';
import AudioToggle from '@/components/audio';
import AudioPlayer from '@/components/audioplayer';
import {onIntersect} from '@/utils/onIntersect';

export default {
  props: ['activeOption'],
  components:{AudioToggle, AudioPlayer, expandIcon},
  setup (props) {
    const store = useStore()
    const ASSETS = ref(process.env.VUE_APP_ASSETS);
    const observer = ref({});

    let maincontainer = ref(undefined) 
    let AudioSync = ref({});
    let syncData = ref();
    let audioPlayer;
    let currentIndex = ref(undefined);
    let audiocontainer = ref(undefined);

    let playSound = ref(false);

    const subtitlescontainer = ref(null);

    onMounted(() => {
      if(!props.activeOption.subtitles || !props.activeOption.subtitles.data) return;

      AudioSync.value = new audioSync({
        subtitlesFile: ASSETS.value + '' + props.activeOption.subtitles.data.attributes.url // the path to the vtt file
      });
      
      AudioSync.value.init().then(successCallback, failureCallback);
      

      playInView();

      onTimeUpdate();
    })

    const presentModal = () => {
      store.dispatch('presentModal', syncData.value);
      playSound.value = false;
    }

    const onTimeUpdate= () => {
      audioPlayer = audiocontainer.value.querySelector('audio');

      audioPlayer.addEventListener("timeupdate", (e) => {
        syncData.value.forEach((element, index) => {          
          let currentTime = (e.target.currentTime * 1000);
          if( currentTime >= element.start && currentTime <= element.end ) {
						let el = subtitlescontainer.value.querySelector('#c-' + index);
						if(index === currentIndex.value || !el) return;

            if(el) {
              scrollToElm(subtitlescontainer.value, el, 400);
            }

            currentIndex.value = index;
					}
				});
      });
    }


    const playInView = () => {
        observer.value = onIntersect(maincontainer.value, onEnter, onExit, false, {
          threshold: .7,
        });

      };

      const onEnter = (el) => {
        playSound.value = true;
      }

      const onExit = () => {
        playSound.value = false;
      }

    const onClickVolume = () => {
      store.dispatch('toggleSound');
    }

    function successCallback(syncArr) {
      syncData.value = syncArr;
    }

    function failureCallback() {
      debugger;
    }

    return {
      ASSETS,
      syncData,
      subtitlescontainer,
      audiocontainer,
      onClickVolume,
      store: store,
      currentIndex,
      maincontainer,
      playSound,
      presentModal
    }
  }
}
</script>


<style lang="scss">
 .knd-subtitles {
      margin-top: 2em;

      .pane-audio--toggle {
        margin-bottom: 2em;
      }

      .audio-player {
        margin-top: 1em;
        margin-bottom: 1em;
        text-align: center;
      }

      .subtitles-container {
        margin-top: 2em;
        overflow: hidden;
        height: 250px;
        padding-bottom: 50px;

        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;

          height: 50px;
          background: linear-gradient(0.53deg, #28006d 0%, rgb(40 0 109 / 70%) 60%, rgba(52, 7, 108, 0) 100%);
      }

        @include md { 
          overflow: scroll;

        }

        span {
          display: block;
          color: #B3B3B3;
          opacity: .9;
          transition: color .6s ease;
          font-weight: bold;
          font-size: 1em;
          &.active {
            font-weight: bold;
            color: #FFF;
            opacity: 1;
          }
        }

      }

      .sub {
        position: relative;
      }

      .expand-icon-container .knd-icon-expand {
        margin-left: auto;
        margin-right: 0;

        --icon-expand-color: #310190;
        --icon-expand-size: 25px;
      }
    }
</style>